export default () => ({
  personalArray: [],
  personalCounter: 0,
  loadingState: true
});